export default {
    path: '/Payments',
    meta: {
        title: '收银台',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/Payment_energy`),
}


// WEBPACK FOOTER //
// ./src/views/payment_energy/router.js